export enum BidLevel {
    Best = 0,
    Cover = 1,
    Third = 2,
    Fourth = 3,
    Fifth = 4
}
